import React from 'react';
import { useDrag } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import ComponentItem from 'components/ComponentItem';
import { IComponentItemOwnProps } from 'components/ComponentItem/models';
import { DragSourceType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import { isSSIElementOnArtboard as isSSIElementOnArtboardSelector } from 'containers/Artboards/selectors';

const SSIElement: React.FC<IComponentItemOwnProps> = (props) => {
  const dispatch = useDispatch();
  const isSSIElementOnArtboard = useSelector(isSSIElementOnArtboardSelector);
  const dragSourceType = DragSourceType.SSI;
  const [{ isDragging }, dragRef] = useDrag<object, void, { isDragging: boolean }>({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType));

      return {};
    },
    end: () => {
      dispatch(toggleDragState());
    },
    canDrag() {
      return !isSSIElementOnArtboard;
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return <ComponentItem {...props} connectDragSource={dragRef} isDragging={isDragging} />;
};

export default SSIElement;
